import type { Token, Tokens } from 'marked';

export const HEX_COLOR_TOKEN_NAME = 'hex_color';

export interface HexColorToken extends Tokens.Generic {
  type: typeof HEX_COLOR_TOKEN_NAME;
  raw: string;
  text: string;
  hex: string;
}

export function isHexColorToken(token: Token): token is HexColorToken {
  if (token.type !== HEX_COLOR_TOKEN_NAME) {
    return false;
  }

  return 'hex' in token;
}
